import _ from 'lodash';
import moment from 'moment';

import {
  momentIsBetweenDatesInclusive,
} from './index';

import store from '../store';

const NOW = undefined;
//const NOW = '1/12/2019';
//const NOW = '9/23/2018';
//const NOW = '9/24/2018';
//const NOW = '10/08/2018';
//const NOW = '12/12/2018';
//const NOW = '12/31/2018';
//const NOW = '1/10/2019';
//const NOW = '3/28/2019';
//const NOW = '4/6/2019';
//const NOW = '6/24/2019';

//const NOW = '01/03/2017';
//const NOW = '01/03/2019';

export function currentlyInQuarterForDate(date){
  return  moment(NOW).format('YYYY') === moment(date).format('YYYY') && moment(NOW).quarter() === moment(date).quarter();
}
window.currentlyInQuarterForDate = currentlyInQuarterForDate;

export function getFormattedQuarterFromDate(date){
  return `${moment(date).year()} Q${moment(date).quarter()}`;
}

export function getCurrentReportingAndEvaluationYear(){
  const { evaluationPeriodStartOffset, evaluationPeriodDuration, quarterOneStartMonthOffset } = (store.getState().organization.data || {})

  // console.log('evaluationPeriodStartOffset: ', evaluationPeriodStartOffset);
  // console.log('evaluationPeriodDuration: ', evaluationPeriodDuration);
  // console.log('quarterOneStartMonthOffset: ', quarterOneStartMonthOffset);

  //explanation:
  //compare current date with most recent q4 end of evaluation
  //if after, this year is current year
  //if before, this year is last year
  const now = moment(NOW);
  const lastYearEnd = moment(NOW).startOf('year').subtract(1, 'days');
  const lastYearQ4End = moment(lastYearEnd).add(quarterOneStartMonthOffset, 'months').endOf('month');
  const lastYearQ4EndOfReportingPeriod = moment(lastYearQ4End).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks');
  const lastYearQ4EndOfEvaluationPeriod = moment(lastYearQ4EndOfReportingPeriod).add(evaluationPeriodDuration, 'weeks').subtract(1, 'days');

  // console.log('lastYearQ4EndOfEvaluationPeriod: ', lastYearQ4EndOfEvaluationPeriod.format('M/D/YYYY'));

  const nowToEndLastYearQ4EvaluationPeriod = now.diff(lastYearQ4EndOfEvaluationPeriod, 'days');

  // console.log('diff: ', nowToEndLastYearQ4EvaluationPeriod);

  //still in "last year" reporting
  if(nowToEndLastYearQ4EvaluationPeriod <= 0){
    return moment(NOW).year() - 1;
  }
  else{
    return moment(NOW).year();
  }
}

export function getReportingAndEvaluationPeriodsForThisYear(){
  const { evaluationPeriodStartOffset, evaluationPeriodDuration, quarterOneStartMonthOffset } = (store.getState().organization.data || {})

  // console.log('evaluationPeriodStartOffset: ', evaluationPeriodStartOffset);
  // console.log('evaluationPeriodDuration: ', evaluationPeriodDuration);
  // console.log('quarterOneStartMonthOffset: ', quarterOneStartMonthOffset);

  const now = moment(NOW);
  const thisYear = getCurrentReportingAndEvaluationYear();
  const lastYear = thisYear - 1;

  const lyq4e = moment(`12/31/${lastYear}`).add(quarterOneStartMonthOffset, 'months').endOf('month');
  const q1s = moment(`1/1/${thisYear}`).add(quarterOneStartMonthOffset, 'months').startOf('month');
  const q1e = moment(`3/31/${thisYear}`).add(quarterOneStartMonthOffset, 'months').endOf('month');
  const q2s = moment(`4/1/${thisYear}`).add(quarterOneStartMonthOffset, 'months').startOf('month');
  const q2e = moment(`6/30/${thisYear}`).add(quarterOneStartMonthOffset, 'months').endOf('month');
  const q3s = moment(`7/1/${thisYear}`).add(quarterOneStartMonthOffset, 'months').startOf('month');
  const q3e = moment(`9/30/${thisYear}`).add(quarterOneStartMonthOffset, 'months').endOf('month');
  const q4s = moment(`10/1/${thisYear}`).add(quarterOneStartMonthOffset, 'months').startOf('month');
  const q4e = moment(`12/31/${thisYear}`).add(quarterOneStartMonthOffset, 'months').endOf('month');

  // console.log('lyq4e: ', lyq4e.format('M/D/YY'));
  // console.log('q1s: ', q1s.format('M/D/YY'));
  // console.log('q1e: ', q1e.format('M/D/YY'));
  // console.log('q2s: ', q2s.format('M/D/YY'));
  // console.log('q2e: ', q2e.format('M/D/YY'));
  // console.log('q3s: ', q3s.format('M/D/YY'));
  // console.log('q3e: ', q3e.format('M/D/YY'));
  // console.log('q4s: ', q4s.format('M/D/YY'));
  // console.log('q4e: ', q4e.format('M/D/YY'));

  const startOfQ1Reporting = moment(lyq4e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks').add(evaluationPeriodDuration, 'weeks');
  const endOfQ1Reporting = moment(q1e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks');
  const startOfQ1Evaluation = endOfQ1Reporting;
  const endOfQ1Evaluation = moment(startOfQ1Evaluation).add(evaluationPeriodDuration, 'weeks').subtract(1, 'days');

  const startOfQ2Reporting = moment(q1e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks').add(evaluationPeriodDuration, 'weeks');
  const endOfQ2Reporting = moment(q2e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks');
  const startOfQ2Evaluation = endOfQ2Reporting;
  const endOfQ2Evaluation = moment(startOfQ2Evaluation).add(evaluationPeriodDuration, 'weeks').subtract(1, 'days');

  const startOfQ3Reporting = moment(q2e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks').add(evaluationPeriodDuration, 'weeks');
  const endOfQ3Reporting = moment(q3e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks');
  const startOfQ3Evaluation = endOfQ3Reporting;
  const endOfQ3Evaluation = moment(startOfQ3Evaluation).add(evaluationPeriodDuration, 'weeks').subtract(1, 'days');

  const startOfQ4Reporting = moment(q3e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks').add(evaluationPeriodDuration, 'weeks');
  const endOfQ4Reporting = moment(q4e).startOf('isoweek').add(evaluationPeriodStartOffset, 'weeks');
  const startOfQ4Evaluation = endOfQ4Reporting;
  const endOfQ4Evaluation = moment(startOfQ4Evaluation).add(evaluationPeriodDuration, 'weeks').subtract(1, 'days');

  let reportingAndEvaluationPeriods = {
    q1: {
      index: 'q1',
      year: thisYear,
      label: `${thisYear} Q1`,
      reportingDates: {
        start: startOfQ1Reporting,
        end: endOfQ1Reporting,
        numWeeks: endOfQ1Reporting.diff(startOfQ1Reporting, 'weeks'),
      },
      evaluationDates: {
        start:startOfQ1Evaluation,
        end: endOfQ1Evaluation,
        numWeeks: evaluationPeriodDuration
      },
      isCurrent: momentIsBetweenDatesInclusive(now, startOfQ1Reporting, endOfQ1Evaluation)
    },
    q2: {
      index: 'q2',
      year: thisYear,
      label: `${thisYear} Q2`,
      reportingDates: {
        start: startOfQ2Reporting,
        end: endOfQ2Reporting,
        numWeeks: endOfQ2Reporting.diff(startOfQ2Reporting, 'weeks'),
      },
      evaluationDates: {
        start:startOfQ2Evaluation,
        end: endOfQ2Evaluation,
        numWeeks: evaluationPeriodDuration
      },
      isCurrent: momentIsBetweenDatesInclusive(now, startOfQ2Reporting, endOfQ2Evaluation)
    },
    q3: {
      index: 'q3',
      year: thisYear,
      label: `${thisYear} Q3`,
      reportingDates: {
        start: startOfQ3Reporting,
        end: endOfQ3Reporting,
        numWeeks: endOfQ3Reporting.diff(startOfQ3Reporting, 'weeks'),
      },
      evaluationDates: {
        start:startOfQ3Evaluation,
        end: endOfQ3Evaluation,
        numWeeks: evaluationPeriodDuration
      },
      isCurrent: momentIsBetweenDatesInclusive(now, startOfQ3Reporting, endOfQ3Evaluation)
    },
    q4: {
      index: 'q4',
      year: thisYear,
      label: `${thisYear} Q4`,
      reportingDates: {
        start: startOfQ4Reporting,
        end: endOfQ4Reporting,
        numWeeks: endOfQ4Reporting.diff(startOfQ4Reporting, 'weeks'),
      },
      evaluationDates: {
        start:startOfQ4Evaluation,
        end: endOfQ4Evaluation,
        numWeeks: evaluationPeriodDuration
      },
      isCurrent: momentIsBetweenDatesInclusive(now, startOfQ4Reporting, endOfQ4Evaluation)
    },
  }

  let currentQuarterData = null;

  _.each(['q1', 'q2', 'q3', 'q4'], quarterIndex => {
    if(reportingAndEvaluationPeriods[quarterIndex].isCurrent){
      currentQuarterData = reportingAndEvaluationPeriods[quarterIndex];

      currentQuarterData.isEvaluating = momentIsBetweenDatesInclusive(now, currentQuarterData.evaluationDates.start, currentQuarterData.evaluationDates.end);
      currentQuarterData.isReporting = !currentQuarterData.isEvaluating;
      currentQuarterData.status = currentQuarterData.isEvaluating ? 'evaluating' : 'reporting';
    }
  });

  reportingAndEvaluationPeriods.current = currentQuarterData;

  // console.log('currentPeriod: ', reportingAndEvaluationPeriods.current);

  return reportingAndEvaluationPeriods;
}
window.getReportingAndEvaluationPeriodsForThisYear = getReportingAndEvaluationPeriodsForThisYear;

export function isInEvaluationPeriodForCurrentQuarter(){
  // console.log('getReportingAndEvaluationPeriodsForThisYear(): ', getReportingAndEvaluationPeriodsForThisYear());
  return getReportingAndEvaluationPeriodsForThisYear().current.isEvaluating;
}

export function isWithinOneMonthOfLastEvaluationPeriod(){
  // console.log(getReportingAndEvaluationPeriodsForThisYear().current.reportingDates.start);
  // console.log('diff: ', moment().diff(getReportingAndEvaluationPeriodsForThisYear().current.reportingDates.start, 'days'));
  return moment().diff(getReportingAndEvaluationPeriodsForThisYear().current.reportingDates.start, 'days') < 30;
}

export function getCurrentQuarterString(){
  return getReportingAndEvaluationPeriodsForThisYear().current.label;
}
export function getNextQuarterString(){
  const currentQuarter = getReportingAndEvaluationPeriodsForThisYear().current;
  const currentQuarterIndex = currentQuarter.index;

  switch(currentQuarterIndex){
    case 'q1':
      return currentQuarter.year + ' Q2';
    case 'q2':
      return currentQuarter.year + ' Q3';
    case 'q3':
      return currentQuarter.year + ' Q4';
    case 'q4':
      return (currentQuarter.year + 1) + ' Q4';
  }
}
export function getLastQuarterString(){
  const currentQuarter = getReportingAndEvaluationPeriodsForThisYear().current;
  const currentQuarterIndex = currentQuarter.index;

  switch(currentQuarterIndex){
    case 'q1':
      return (currentQuarter.year - 1) + ' Q4';
    case 'q2':
      return currentQuarter.year + ' Q1';
    case 'q3':
      return currentQuarter.year + ' Q2';
    case 'q4':
      return currentQuarter.year + ' Q3';
  }
}
export function getCurrentEvaluationDate(){
  return getReportingAndEvaluationPeriodsForThisYear().current.evaluationDates.end;
}
export function getCurrentQuarterReviewType(){
  return getReportingAndEvaluationPeriodsForThisYear().current.index === 'q4' ? 'annual' : 'quarter';
}



// WEBPACK FOOTER //
// ./src/util/quarters.js